// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"146":"fea2ec488ddab8da","7109":"3dea10dfa1101969"}[chunkId] + ".css";
};